import { LemsarApiClient } from './../../../api/client';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EquipmentCategory } from '@lemsar/institution/domains/model/equipment';
import { ResponseTransformer } from '@lemsar/api/transformers/response';

@Injectable()
export class EquipmentCategoryService {
    public constructor(private api: LemsarApiClient) {}

    public fetchAll(alias?: string): Observable<EquipmentCategory[]> {
        const queryParams = !alias ? {} : { alias: alias };

        return this.api
            .get<any>('equipment-categories', queryParams)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(EquipmentCategory));
    }

    // public fetchByType(type: string): Observable<EquipmentCategory[]> {
    //     return this.api
    //         .get<any>('building-types?type=' + type)
    //         .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(EquipmentCategory));
    // }
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/services/equipment-category.service.ts